import { Input } from "../../../components/Input/input";
import styled from "styled-components";
import * as yup from "yup";
import { useFormik } from "formik";
import { theme } from "../../../helpers/theme";
import { useEffect, useState } from "react";
import { ClientAddBody } from "../../../services/clients/add/types";
import { useMutation } from "@tanstack/react-query";
import { postCheckEmail } from "../../../services/users/check-email";

interface ClientAddFormProps {
  clientAddDisabled: boolean;
  setClientData: (clientData: ClientAddBody | null) => void;
  clientData: ClientAddBody | null;
  setClientId: (clientId: string | null) => void;
  clientId: string | null;
  setClientDataValid: (clientDataValid: boolean) => void;
  clientPickedData: ClientAddBody | null;
  clientAdditionalInfo: string | null;
  setClientAdditionalInfo: (clientAdditionalInfo: string) => void;
}

export const ClientAddForm = ({clientAddDisabled, setClientId, clientId, setClientDataValid, setClientData, clientData, clientPickedData, clientAdditionalInfo, setClientAdditionalInfo}:ClientAddFormProps) => {
  const [disableOption, setDisableOption] = useState<boolean>(clientAddDisabled);

  useEffect(() => {
    setDisableOption(clientAddDisabled);
  }, [clientAddDisabled]);

  const CheckEmail = useMutation(postCheckEmail, {
    onSuccess: (res) => {
    },
    onError: (err) => {
      setClientDataValid(false);
    },
  });


  const handleBlurEvent = () => {
    if (formik.values.email !== "") {
      CheckEmail.mutate({
        email: formik.values.email,
        rola: null
      });
    }
  };

  const handleEmailBlur = (e:any) => {
    handleBlurEvent();
    formik.handleBlur(e);
  };

  const validationSchema = yup.object({
    nazwa: yup
      .string()
      .max(50, "Nazwa nie może być dłuższa niż 50 znaków")
      .required("Nazwa jest wymagana"),
    nip: yup
      .number()
      .typeError("Błędny format!")
      .required("NIP jest wymagany")
      .min(1000000000, "NIP musi mieć 10 cyfr i nie może zaczynać się od 0")
      .max(9999999999, "NIP musi mieć 10 cyfr"),
    telefon: yup
      .number()
      .typeError("Błędny format!")
      .required("Telefon jest wymagany")
      .min(100000000, "Telefon musi mieć 9 cyfr i nie może zaczynać się od 0")
      .max(999999999, "Telefon musi mieć 9 cyfr"),
    email: yup
      .string()
      .required("Email jest wymagany")
      .email("Błędny format adresu E-mail"),
    info_dodatkowe: yup
      .string()
      .nullable()
      .max(100, "Informacje dodatkowe nie mogą być dłuższe niż 100 znaków"),

  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nazwa: clientData ? clientData.nazwa : (clientPickedData ? clientPickedData.nazwa : ""),
      nip: clientData ? clientData.nip : (clientPickedData ? clientPickedData.nip : ""),
      telefon: clientData ? clientData.telefon : (clientPickedData ? clientPickedData.telefon : ""),
      email: clientData ? clientData.email : (clientPickedData ? clientPickedData.email : ""),
      adres_id: null,
      info_dodatkowe: clientData ? clientData.info_dodatkowe : (clientAdditionalInfo ? clientAdditionalInfo : null),
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
    },
  });

  useEffect(() => {
    if ((clientPickedData ===null || clientPickedData === undefined) && formik.isValid && formik.values.nazwa !== "" && formik.values.nip !== "" && formik.values.telefon !== "" && formik.values.email !== "") {
      setClientDataValid(true);
      setClientData(formik.values);
    } else if (!formik.isValid) {
      setClientData(formik.values);
      setClientDataValid(false);
    } else if (clientPickedData !== null) {
      setClientDataValid(true);
      if (formik.values.info_dodatkowe !== null && (clientPickedData?.info_dodatkowe === null || clientPickedData?.info_dodatkowe === "")){
        setClientAdditionalInfo(formik.values.info_dodatkowe);
      }
    } else {
      setClientDataValid(false);
    }
  }, [formik.values, formik.isValid]);

  return (
    <>
    <ClientAddFormWrapper>
    <BasicFormWrapper onSubmit={formik.handleSubmit}>
      <FormWrapper>
        <Input
          label="Nazwa*"
          id="nazwa"
          name="nazwa"
          value={formik.values.nazwa}
          onChange={formik.handleChange}
          error={formik.touched.nazwa && Boolean(formik.errors.nazwa)}
          helperText={formik.touched.nazwa && formik.errors.nazwa}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          disabled={disableOption}
        />
        <Input
          label="NIP*"
          id="nip"
          name="nip"
          value={formik.values.nip}
          onChange={formik.handleChange}
          error={formik.touched.nip && Boolean(formik.errors.nip)}
          helperText={formik.touched.nip && formik.errors.nip}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          disabled={disableOption}
        />
        <Input
          label="Email*"
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.touched.email && Boolean(formik.errors.email)}
          helperText={formik.touched.email && formik.errors.email}
          onBlur={handleEmailBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          disabled={disableOption}
        />
        <Input
          label="Telefon*"
          id="telefon"
          name="telefon"
          value={formik.values.telefon}
          onChange={formik.handleChange}
          error={formik.touched.telefon && Boolean(formik.errors.telefon)}
          helperText={formik.touched.telefon && formik.errors.telefon}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          disabled={disableOption}
        />
        <Input
          label="Info dodatkowe"
          id="info_dodatkowe"
          name="info_dodatkowe"
          value={formik.values.info_dodatkowe}
          onChange={formik.handleChange}
          error={formik.touched.info_dodatkowe && Boolean(formik.errors.info_dodatkowe)}
          helperText={formik.touched.info_dodatkowe && formik.errors.info_dodatkowe}
          onBlur={formik.handleBlur}
          variant="filled"
          style={{ marginTop: 11 }}
          // disabled={disableOption}
        />
      </FormWrapper>
    </BasicFormWrapper>

    </ClientAddFormWrapper>
    </>
  );
};

export default ClientAddForm;


const ClientAddFormWrapper = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  // margin-left: 320px;
  padding-right: 0;
  margin-top: 25px;
  @media (${theme.device.laptop}) {
    // width: 70%;
  }
`;

const BasicFormWrapper = styled.form`
  width: 100%;
  margin-bottom: 40px;
  display: flex;
  justify-content: center;
  // padding: 0 40px;

  @media (${theme.device.laptop}){
    width: 100%;
    // padding: 0 10px;
  }
`;

const FormWrapper = styled.div`
  width: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width:260px;
  max-width:420px;
  gap: 25px;

  @media (${theme.device.laptop}){
    width: 100%;
  }
`;